import axios from "axios";
import { Buffer } from 'buffer';

var username = 'user';
var password = 'pass';
const token = `${username}:${password}`;
const encodedToken = Buffer.from(token).toString('base64');


const api = axios.create({
    baseURL: 'https://dkcomunica.com.br:8888/appConfirmaAgenda/ConfirmarAgendaServer.dll/',//'https://dkcomunica.com.br:8888/appConfirmaAgenda/ConfirmarAgendaServer.dll/',//'http://localhost:7000/', 'http://200.98.82.71:7000/'
    headers:{
        'Accept': 'application/json',
        'Content': 'application/json',
      //  'Authorization': 'Basic '+ encodedToken
    }

});

export default api